<template>
  <div id="form-config-slideshow-add">
    <CRow class="mt-4">
      <CCol md="10">
        <CCard style="border-radius: unset!important;" @click.stop="clickCard">
          <CCardHeader style="border-radius: unset!important;position: unset!important;" color="light"
                       class="d-inline-flex justify-content-between align-items-center">
            <div>
              <strong style="font-size: 18px;"> Cấu hình nội dung trình diễn </strong>
            </div>
            <div>
              <CButton color="secondary" class="text-right" v-c-tooltip.hover="'Thêm nội dung'" @click="addLayer()">
                <i class="fa fa-plus"></i>&nbsp;
              </CButton>&nbsp;&nbsp;
              <CButton color="secondary" class="text-right" :disabled="isDisabledRemoveLayer"
                       :style="isDisabledRemoveLayer ? 'cursor:no-drop' : ''" @click="removeLayer()">
                <i class="fa fa-trash"></i>&nbsp;
              </CButton>&nbsp;&nbsp;
            </div>
          </CCardHeader>
          <CCardBody style="padding: unset!important; height: 75vh;overflow: hidden;" class="vs-editor root-editor" ref="cardBody">
            <div class="vs-editor-canvas">
              <template>
                <Draggable v-for="(each) of items.slice().reverse()" :key="each.id" :item="each"
                           @active:layer="activeElementLayerDraggable"/>
              </template>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="2">
        <ConfigSlideShowEditor :items="items" :action="actionSlideShow" :size="sizeDesign" :type="typeArea"
                               :itemSelected="itemSelectedEditor"
                               @choose:layer="chooseLayerEditor" @active:layer="activeLayerEditor"
                               @change:layer="changeLayerEditor"
                               @remove:layer="removeLayerEditor"
                               @change:type="changeTypeArea" @loading="loadingLayerEditor"/>
      </CCol>
    </CRow>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>
<script>

import {ActionEditor, TypeChooseLayer} from '../../../constant';
import BaseFormLoading from "@/views/base/BaseFormLoading";
import Draggable from "@/views/slide_show/Dragable";
import ConfigSlideShowEditor from "@/views/slide_show/central/ConfigSlideShowEditor";

export default {
  name: 'SlideShowAdd',
  components: {ConfigSlideShowEditor, Draggable, BaseFormLoading},
  data: function () {
    return {
      isDisabledRemoveLayer: true,
      typeArea: 0,
      sizeDesign: {},
      loading: {value: false},
      actionEditor: ActionEditor,
      typeChooseLayer: TypeChooseLayer,
      typeLayer: null,
      items: [],
      actionSlideShow: 0,
      itemSelectedEditor: null,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getDimensions();
    window.addEventListener('resize', this.getDimensions);
  },
  methods: {
    getDimensions() {
      const {width, height} = this.$refs.cardBody.getBoundingClientRect();
      this.sizeDesign = {
        width: width,
        height: height,
      }
    },
    activeElementLayerDraggable(item) {
      this.items.map((each, index) => {
        if (each.id != item.id) {
          each.active = false;
        } else {
          each.active = true;
          this.itemSelectedEditor = index;
          this.actionSlideShow = this.actionEditor.EDITOR_LAYER;
          this.isDisabledRemoveLayer = false;
        }
      })
    },
    removeLayer() {
      this.items.map((each, index) => {
        if (index === this.itemSelectedEditor) {
          this.items.splice(index, 1);
          this.actionSlideShow = this.actionEditor.LAYOUT_SETTING;
          this.isDisabledRemoveLayer = true;
        }
      })
    },
    clickCard(e) {
      // eslint-disable-next-line no-undef
      if ($(e.target).is('div.yoyoo-ddr') || $(e.target).parents().is('div.yoyoo-ddr') || $(e.target).is('button') || $(e.target).is('strong')) {
        return false;
      }
      this.items.map((each) => each.active = false);
      this.actionSlideShow = this.actionEditor.LAYOUT_SETTING;
      this.isDisabledRemoveLayer = true;
    },
    submitActionEditor(type) {
      this.actionSlideShow = type;
    },
    addLayer() {
      if (this.typeArea == 0) { /* Toàn màn hình */
        if (this.items.length == 0) {
          var width = this.$refs.cardBody.clientWidth;
          var height = this.$refs.cardBody.clientHeight;
          this.item = {
            id: new Date().getTime(),
            active: true,
            draggable: true,
            rotatable: false,
            extractData: {
              typeLayer: this.typeChooseLayer.FULL_SCREEN
            },
          }
          this.item.attr = {
            isMuted: false
          };
          this.item.acceptRatio = false;
          this.item.minWidth = width;
          this.item.minHeight = height;
          this.item.transform = {
            x: 0,
            y: 0,
            width: width,
            height: height,
            rotation: 0
          };
          this.items.unshift(this.item);
          // this.actionSlideShow = this.actionEditor.EDITOR_LAYER;
          this.itemSelectedEditor = 0;
          this.isDisabledRemoveLayer = false;
        }
      } else {
        this.submitActionEditor(this.actionEditor.ADD_LAYER)
      }
    },
    chooseLayerEditor(value) {
      // this.typeLayer = value.type;
      this.loading.value = true;
      var width = this.$refs.cardBody.clientWidth;
      var height = this.$refs.cardBody.clientHeight;
      var center = {x: (width - (width / 2)) / 2, y: (height - (height / 2)) / 2};
      if (value && (value.typeLayer != null && value.typeLayer != undefined)) {
        this.item = {
          id: new Date().getTime(),
          active: true,
          draggable: true,
          rotatable: false,
          extractData: value,
        }
        switch (value.typeLayer) {
          case this.typeChooseLayer.AREA_TEXT : {
            this.item.attr = {
              direction: 'left',
              color: '#000000',
              fontSize: '20',
              fontWeight: '400',
              background: 'rgba(255,255,255,0)',
              letterSpacing: 0,
              font: 'Arial',
              lineHeight: '30',
              textAlign: 'center',
              fontStyle: 'normal',
              textDecoration: 'none',
              speed: 50
            };
            this.item.acceptRatio = false;
            this.item.minWidth = 300;
            this.item.minHeight = 58;
            this.item.transform = {
              x: (width - (width / 2)) / 2,
              y: center.y,
              width: width / 2,
              height: 58,
              rotation: 0
            };
            break;
          }
          case this.typeChooseLayer.AREA_LEFT : {
            this.item.attr = {
              isMuted: false
            };
            this.item.acceptRatio = false;
            this.item.minWidth = 300;
            this.item.minHeight = 150;
            this.item.transform = {
              x: center.x,
              y: center.y,
              width: width / 2,
              height: height / 2,
              rotation: 0
            };
            break;
          }
          case this.typeChooseLayer.AREA_RIGHT : {
            this.item.attr = {
              isMuted: false
            };
            this.item.acceptRatio = false;
            this.item.minWidth = 300;
            this.item.minHeight = 150;
            this.item.transform = {
              x: center.x,
              y: center.y,
              width: width / 2,
              height: height / 2,
              rotation: 0
            };
            break;
          }
        }
        this.items.map(each => each.active = false);
        this.loading.value = false;
        this.items.unshift(this.item);
        this.actionSlideShow = this.actionEditor.EDITOR_LAYER;
        this.itemSelectedEditor = 0;
        this.isDisabledRemoveLayer = false;
      }
    },
    activeLayerEditor(id) {
      if (this.items && this.items.length > 0 && id) {
        this.items.find((each, index) => {
          if (each.id === id) {
            each.active = true;
            this.itemSelectedEditor = index;
            this.actionSlideShow = this.actionEditor.EDITOR_LAYER;
            this.isDisabledRemoveLayer = false;
          }
        })
      }
    },
    removeLayerEditor(id) {
      if (this.items && this.items.length > 0 && id) {
        this.items.map((each, index) => {
          if (each.id === id) {
            this.items.splice(index, 1);
            this.actionSlideShow = this.actionEditor.LAYOUT_SETTING;
          }
        })
      }
    },
    loadingLayerEditor(value) {
      this.loading.value = value;
    },
    changeLayerEditor() {
    },
    changeTypeArea(value) {
      this.typeArea = Number(value);
      this.items = [];
    },
  },
  watch: {},
  destroyed() {
    window.removeEventListener('resize', this.getDimensions);
  }
}
</script>

<style scoped>
video {
  object-fit: cover;
}

.vs-editor-canvas {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgba(243, 238, 238, 0.91);
  background-image: linear-gradient(0deg, rgba(166, 158, 158, 0.1) 0, transparent 1px), linear-gradient(90deg, rgba(112, 86, 86, 0.1) 1px, transparent 1px);
  background-size: 26px 14px, 26px 14px;
}


.layout-insert-item-column {
  text-align: center;
}

.selected {
  border: 2px solid #118bff;
}

.layout-insert-item-type {
  border-radius: 3px;
  width: 100%;
  height: 140px;
  background: #dcdcdc;
  color: #fff;
  cursor: pointer;
  transition: all ease-in-out .2s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 5px 0px #adb5bd;
}

.layout-insert-item-type img {
  width: 100%;
  height: 100%;
}

.layout-insert-item-type.selected ~ .layout-insert-item-label {
  color: #6458ff;
  font-weight: bold;
}

.layout-insert-item-label {
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}
</style>
<style lang="scss">
#form-config-slideshow-add {
  .custom-content-modal {
    height: 80vh;
  }

  .nav-link {
    padding: 0.8rem 1rem;
  }

  .folder-local-files {
    width: 100%;
    height: 120px;
    box-shadow: 0 0 5px 0 #adb5bd;

    img {
      width: 100%;
      height: 100%;
    }
  }

  i {
    width: unset;
  }

  tr {
    cursor: pointer;
  }

}
</style>
